import request from "@/utils/http";

export default {
  namespaced: true,
  state: {
    detail: {},
  },
  mutations: {
    // 初始化详情
    INIT_DETAIL(state, detail) {
      state.detail = { ...detail };
    },
    // 设置详情
    SET_DETAIL(state, detail) {
      state.detail = { ...state.detail, ...detail };
    },
    // 重置详情
    RESET_DETAIL(state) {
      state.detail = {};
    },
  },
  actions: {
    // 订单详情
    initOrder({ commit }, orderId) {
      return new Promise((resolve, reject) => {
        request
          .get(`/admin/orderManage/${orderId}/detail`)
          .then(({ code, data, msg }) => {
            if (code === 200) {
              commit("INIT_DETAIL", data);
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 退款单详情
    initRefundOrder({ commit }, orderId) {
      return new Promise((resolve, reject) => {
        request
          .get(`/admin/orderRefundManage/${orderId}/detail`)
          .then(({ code, data, msg }) => {
            if (code === 200) {
              commit("INIT_DETAIL", data);
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 确认转账 - 财务
    doReceipt({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        let applymentId = state.detail.id;
        request
          .post(`/admin/orderManage/${applymentId}/transferVerify`, {
            ...payload,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              const newDetail = {
                ...this.detail,
                status: payload.status,
                transferVerifyRemark: payload.remark,
                payType: payload.payType,
                isInvoiceRevised: payload.isInvoiceRevised,
                revisedInvoiceFile: payload.revisedInvoiceFile,
              };
              commit("SET_DETAIL", newDetail);
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 确认退款 - 财务
    doRefund(_, payload) {
      return new Promise((resolve, reject) => {
        request
          .post("/admin/orderRefundManage/refund", {
            refundId: payload.id,
            status: payload.status,
            failReason: payload.failReason,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //批量收款 - 财务
    doBatchReceipt(_, payload) {
      return new Promise((resolve, reject) => {
        request
          .post(`/admin/orderManage/batchTransferVerify`, {
            ...payload,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 批量退款 - 财务
    doBatchRefund(_, payload) {
      return new Promise((resolve, reject) => {
        request
          .post("/admin/orderRefundManage/batchRefund", {
            ...payload,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 发起后付款 - 财务
    doApplyCredit({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const id = state.detail.id;
        request
          .post(`/admin/orderManage/${id}/applyCredit`, {
            applyReason: payload.applyReason,
            attachmentUrls: payload.attachmentUrls,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              const newDetail = { ...this.detail, credit: payload.credit, creditStatus: payload.creditStatus };
              commit("SET_DETAIL", newDetail);
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 后付款审批 - 财务复核
    doAuditCredit({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const id = state.detail.id;
        request
          .post(`/admin/orderManage/${id}/auditCredit`, {
            auditRemark: payload.auditRemark,
            creditStatus: payload.creditStatus,
            attachmentUrls: payload.attachmentUrls,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              const newDetail = { ...this.detail, credit: payload.credit, creditStatus: payload.creditStatus };
              commit("SET_DETAIL", newDetail);
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 废弃订单 - 财务
    doForfeitOrder({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const id = state.detail.id;
        request
          .post("/admin/orderManage/forfeit", {
            orderId: id,
          })
          .then(({ code, msg }) => {
            if (code === 200) {
              const newDetail = { ...this.detail, status: payload.status };
              commit("SET_DETAIL", newDetail);
              resolve();
            } else {
              reject(msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
  },
};
